module.exports = __webpack_public_path__ + "de2ace3bdb5e191ba2d20e15ba9ad2ce.png";